import React, { useState , useEffect , useRef } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";

const ManageFooterDialog = ({
  visible,
  onHide,
  footers,
  onSaveEdit,
}) => {
  const [selectedFooter, setSelectedFooter] = useState(null);
  const [editedContent, setEditedContent] = useState("");
  const [searchText, setSearchText] = useState("");

const editorRef = useRef(null);

// Add this useEffect inside your component
useEffect(() => {
  if (selectedFooter && editedContent) {
    setTimeout(() => {
      const quill = editorRef.current?.getQuill?.();
      if (quill) {
        quill.clipboard.dangerouslyPasteHTML(editedContent);
      }
    }, 0);
  }
}, [selectedFooter]);

  const handleEdit = (rowData) => {
    setSelectedFooter(rowData);
    setEditedContent(rowData.content);
  };

  const filteredFooters = footers.filter((footer) =>
    footer.name
      ?.toLowerCase()
      .includes(searchText.toLowerCase())
  );

  return (
    <Dialog
      header="View / Edit Footers"
      visible={visible}
      style={{ width: selectedFooter ? "55rem" : "45rem" }}
      contentStyle={{ overflowX: "hidden" , overflowY: "hidden" }}
      onHide={() => {
        setSelectedFooter(null);
        setEditedContent("");
        setSearchText("");
        onHide();
      }}
    >
      {/* Footer List */}
      {!selectedFooter && (
        <div className="flex flex-column gap-4">

          {/* Search */}
          <div className="flex justify-content-start">
            <span
              className="p-input-icon-left"
              style={{ width: "60%" }}
            >
              <i className="pi pi-search" style={{marginLeft: '6px'}}  />

              <InputText style={{ padding : '12px 44px'}}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search footer by name"
                className="w-full"
              />
            </span>
          </div>

          {/* Table */}
          <DataTable
            value={filteredFooters}
            paginator
            rows={4}
            emptyMessage="No footers found"
            className="p-datatable-sm"
          >
            <Column
              field="name"
              header="Footer Name"
            />

          <Column
  header="Actions"
  headerStyle={{
    textAlign: "center",
    width: "120px",
  }}
  bodyStyle={{
    textAlign: "center",
  }}
  body={(rowData) => (
    <div className="flex">
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-text"
        onClick={() => handleEdit(rowData)}
        tooltip="Edit Footer"
        tooltipOptions={{ position: "top" }}
      />
    </div>
  )}
/>
          </DataTable>

        </div>
      )}

      {/* Edit Screen */}
      {selectedFooter && (
        <div className="flex flex-column gap-4">

          {/* Footer Name */}
          <div>
            <div className="text-sm text-500 mb-2">
              Footer Name
            </div>

            <div className="font-semibold text-900 text-lg">
              {selectedFooter.name}
            </div>
          </div>

          {/* Editor */}
          <Editor
  ref={editorRef}
  key={selectedFooter?.id || selectedFooter?.name}
  value={editedContent}
  onTextChange={(e) => setEditedContent(e.htmlValue)}
  style={{ height: "250px" }}
/>

          {/* Buttons */}
          <div className="flex justify-content-between">
            <Button
              label="Back"
              className="p-button-outlined"
              onClick={() => {
                setSelectedFooter(null);
                setEditedContent("");
              }}
            />

            <Button
              label="Save Changes"
              onClick={() => {
                onSaveEdit({
                  ...selectedFooter,
                  content: editedContent,
                });

                setSelectedFooter(null);
                setEditedContent("");
              }}
            />
          </div>

        </div>
      )}
    </Dialog>
  );
};

export default ManageFooterDialog;